export default __webpack_public_path__ + "static/media/hul.65174561.png";